import React from "react";
import foto1 from "../asset/meet.png";

const Meetclient = () => {
  return (
    <div id="" className="">
      <div className="max-w-[80%] m-auto py-5 px-4 grid lg:grid-cols-2 gap-4  ">
        <div
          className="grid   w-[full]"
          data-aos="fade-down"
          data-aos-duration="2000"
        >
          <img src={foto1} alt="Export Import Activity" />
        </div>
        {/* left Side */}
        <div
          className="flex flex-col h-full justify-center"
          data-aos="fade-down"
          data-aos-duration="1000"
        >
          <div className="text-left max-md:text-sm">
            <h2 className=" font-bold text-dark text-6xl max-md:text-3xl font-EBGaramond  ">
             Meet
              
              <span className="text-primer font-EBGaramond"> with client</span>
            </h2>
          </div>

          <p className="text-dark mb-4  text-2xl md:text-lg max-md:text-lg mt-4 font-Montserrat ">
            "I have a business that focuses on exporting high-quality vanilla. I
            would love it if you could come meet with me to talk more about our
            products and the exciting cooperation opportunities "
            <span className="text-green-800">
               So that we can become the first choice as a supplier of Vanilla
              from Indonesia.
            </span>
            <br />
            <span className="inline-block w-[300px] h-4"></span>
          </p>
          <div className="bg-center max-sm:pt-2 max-sm:mb-2"> </div>
        </div>

        {/* right Side */}
      </div>
    </div>
  );
};

export default Meetclient;
